import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useApiCaller } from '../utils/ApiUtilities';
import { getForgotPasswordUrl } from '../utils/UrlUtilities';
import { constructForgotPasswordPayload } from '../utils/PayloadUtils';

export default function ForgotPassword() {
    const CallApi = useApiCaller();
    const [email, setEmail] = useState('');
    const [sent, setSent] = useState(false);
    const [busy, setBusy] = useState(false);

    const isEmailValid = (e) => /^\S+@\S+\.\S+$/.test(e);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!isEmailValid(email)) return;
        setBusy(true);
        // Server returns a generic success regardless (anti-enumeration).
        await CallApi({
            url: getForgotPasswordUrl(),
            method: 'POST',
            payload: constructForgotPasswordPayload(email),
            token: false,
        });
        setBusy(false);
        setSent(true);
    };

    return (
        <div className="container mt-5" style={{ maxWidth: 420 }}>
            <h2 className="mb-4">Forgot password</h2>
            {sent ? (
                <div className="alert alert-success">
                    If an account exists for <strong>{email}</strong>, a reset link has been sent.
                    Check your inbox (the link is valid for 30 minutes).
                    <div className="mt-3"><Link to="/login">Back to login</Link></div>
                </div>
            ) : (
                <form onSubmit={handleSubmit}>
                    <p className="text-muted">Enter your email and we'll send you a reset link.</p>
                    <div className="mb-3">
                        <label>Email address</label>
                        <input
                            type="email"
                            className={`form-control ${email && !isEmailValid(email) ? 'is-invalid' : ''}`}
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>
                    <button type="submit" className="btn btn-primary w-100" disabled={busy || !isEmailValid(email)}>
                        {busy ? 'Sending…' : 'Send reset link'}
                    </button>
                    <div className="text-center mt-3"><Link to="/login">Back to login</Link></div>
                </form>
            )}
        </div>
    );
}
